import {
    Row,
    SortingState,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import _isNil from 'lodash/isNil';
import React from 'react';
import { isSelectedRow } from '@Components/Settings/components/SettingsTable/Helpers';
import Styles from '@Components/Settings/components/SettingsTable/SettingsTable.scss';

interface IDepartmentsTableProps {
    columns: Array<any>;
    data: Array<any>;
    onRowClick?: (obj: any) => void;
    selectedRow?: any;
    isSubmitting?: boolean;
}

const DepartmentsTable = (props: IDepartmentsTableProps) => {
    const { data, columns, onRowClick, selectedRow, isSubmitting } = props;

    const table = useReactTable({
        data: props.data,
        columns: props.columns,
        getCoreRowModel: getCoreRowModel(),
    });

    const handleRowClick = (row: Row<unknown>) => {
        if (onRowClick) {
            onRowClick(!isSelectedRow(row, selectedRow) ? row.original : null);
        }
    };

    const getTableRowHtml = (row: Row<unknown>) => {
        return (
            <tr
                id={`dept-option-${row.index}`}
                key={row.id}
                onClick={() => handleRowClick(row)}
                className={
                    isSelectedRow(row, selectedRow)
                        ? Styles.selectedDeptRow
                        : null
                }
            >
                {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                        {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                        )}
                    </td>
                ))}
            </tr>
        );
    };

    return (
        <table id="departments-select-table" className={Styles.table}>
            <tbody>
                {table.getRowModel().rows.map((row) => getTableRowHtml(row))}
            </tbody>
        </table>
    );
};

export default DepartmentsTable;
